<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="arrow-right"/>&nbsp;{{ $t('title') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('title')">
      <div class="alert alert-info" v-html="$t('guide')"></div>
      <admin-user-select :label="$t('fromUser')" :status="null" :model="formModel" attribute="fromUser" :errors="formErrors"></admin-user-select>
      <admin-user-select :label="$t('toUsers')" multiple :model="formModel" attribute="toUsers" :errors="formErrors"></admin-user-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="change()">
          {{ $t('change') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
  import AdminUserSelect from "../../components/AdminUserSelect";
  export default {
    components: {AdminUserSelect},
    data() {
      return {
        showForm: false,
        formModel: {
          role: 'bd',
          fromUser: null,
          toUsers: []
        },
        formErrors: []
      }
    },
    methods: {
      open() {
        this.formModel = {role: 'bd', fromUser: null, toUsers: []};
        this.formErrors = [];
        this.showForm = true
      },
      change() {
        this.$swal({
          title: this.$t('changeConfirm'),
          icon: "warning",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
          let loader = this.$loading.show();
          this.$service({
              url: '/client/change-role',
              method: 'post',
              // bỏ chọn hết nhân viên đích = thu hồi khách, phải gửi mảng rỗng chứ không phải null
              data: Object.assign({}, this.formModel, {toUsers: this.formModel.toUsers || []})
            }).then(response => {
              this.showForm = false;
              if (response.data) {
                this.$swal({
                    title: this.$t('success'),
                    text: this.$t('changeSuccess'),
                    icon: 'success'
                });
                this.$bus.$emit('loadClient');
              } else {
                this.$swal({
                    title: this.$t('error'),
                    text: this.$t('changeFailed'),
                    icon: 'error'
                });
              }
            }).catch(error => {
              let data = error.response ? error.response.data : null;
              if (!data) {
                this.$swal({
                  text: this.$t('changeFailed'),
                  icon: 'error'
                });
              } else if (data.message) {
                this.$swal({
                  text: data.message,
                  icon: 'error'
                });
                this.showForm = false;
              } else {
                this.formErrors = data;
              }
            }).finally(() => {
              loader.hide();
            });
          }
        })
      },
    },
    i18n: {
      messages: {
        en: {
          guide: "Clients will be divided evenly among the selected users. If none is selected, clients will be unassigned",
          change: "Change",
          title: "Change Sales",
          fromUser: "From user",
          toUsers: "To users",
          changeConfirm: "Are you sure you want to make this change?",
          changeSuccess: "Change success",
          changeFailed: "Change failed"
        },
        vi: {
          guide: "Khách hàng sẽ được chia đều cho các nhân viên đã chọn. Nếu không chọn, hệ thống sẽ thu hồi khách hàng",
          change: "Thay đổi",
          title: "Thay đổi Sales",
          fromUser: "Chuyển từ nhân viên",
          toUsers: "Tới các nhân viên",
          changeConfirm: "Bạn có chắc chắn muốn thực hiện thay đổi này?",
          changeSuccess: "Thay đổi thành công",
          changeFailed: "Thay đổi thất bại"
        }
      }
    }
  }
</script>
